import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconClapboard: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="clapboard, movie, film"><path d="M21 17.25C21 19.3211 19.3211 21 17.25 21H6.75C4.67893 21 3 19.3211 3 17.25V9.5H21V17.25Z" fill="currentColor"/><path d="M7.20898 8H3V6.75C3 4.67893 4.67893 3 6.75 3H8.87598L7.20898 8Z" fill="currentColor"/><path d="M13.459 8H8.79102L10.458 3H15.126L13.459 8Z" fill="currentColor"/><path d="M17.25 3C19.3211 3 21 4.67893 21 6.75V8H15.041L16.708 3H17.25Z" fill="currentColor"/></CentralIconBase>;
};

export default IconClapboard;
